// Plan 08-07 / Plan 17-07 — DEC-020 + DEC-026 attribution block.
//
// DEC-020 LOCK: the SCOWL + SALDO attribution lines are mandatory legal
// disclosures and MUST appear in both the About screen and the site
// footer. The string content + i18n key shape (`about.attribution.scowl`,
// `about.attribution.saldo`) is PRESERVED VERBATIM by Plan 17-07; only the
// visual literals (gap, fontSize) have been tokenized.

import type { JSX } from 'react'
import { FormattedMessage } from 'react-intl'

interface AttributionProps {
  /** Optional opacity override (default 0.7 per UI-SPEC §footer caption). */
  opacity?: number
}

export function Attribution({ opacity = 0.7 }: AttributionProps): JSX.Element {
  return (
    <div
      data-testid="attribution"
      className="attribution"
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: 'var(--space-2)',
        fontFamily: 'var(--font-family-body)',
        fontWeight: 500,
        fontSize: 'var(--font-size-11)',
        lineHeight: 1.45,
        color: 'var(--color-text-tertiary)',
        opacity,
      }}
    >
      <p style={{ margin: 0 }} data-attribution="scowl">
        <FormattedMessage
          id="about.attribution.scowl"
          defaultMessage="English dictionary: SCOWL (composite open license)."
        />
      </p>
      <p style={{ margin: 0 }} data-attribution="saldo">
        <FormattedMessage
          id="about.attribution.saldo"
          defaultMessage="Svenska ordlista: SALDO från Språkbanken (CC BY 4.0)."
        />
      </p>
    </div>
  )
}
